import React from "react";
import { SFContentContainer } from "@sf-core";
import ProfileStepper from "../../components/profileStepper";
import { useNavigate } from "react-router-dom";
import { getHomeUrl } from "../../constants/urls";
import { removeDomainsByType } from "../../redux/reducers/domainReducer";
import { DOMAIN_TYPES } from "../../constants/domainTypes";
import { useDispatch } from "react-redux";

const ProfileScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Exit profile screen and navigate to home screen
  const onProfileExit = () => {
    //Delete user job courses and user related jobs and jobs of interest
    dispatch(removeDomainsByType(DOMAIN_TYPES.USER_SELECTED_JOB));
    dispatch(removeDomainsByType(DOMAIN_TYPES.USER_JOB_GOAL));
    dispatch(removeDomainsByType(DOMAIN_TYPES.JOB));
    dispatch(removeDomainsByType(DOMAIN_TYPES.USER_SKILL_GOAL));

    navigate(getHomeUrl());
  };

  return (
    <SFContentContainer disableGutters>
      <ProfileStepper onProfileExit={onProfileExit} />
    </SFContentContainer>
  );
};

export default ProfileScreen;
